// src/services/authService.js
import api from '../utils/Api';

/**
 * Helper: normaliza la respuesta del wrapper `api`
 */
const unwrap = (res) => {
  if (!res) return {};
  return res.data ? res.data : res;
};

/**
 * 🔑 Iniciar sesión
 */
export const login = async (correo, password) => {
  try {
    console.log('[AUTH] Payload enviado a /auth/login:', { correo,password });

    const res = await api.post('/auth/login', { correo, password });
    const data = unwrap(res);
    console.log('[AUTH] Respuesta recibida de /auth/login:', data);

    // Normalizar campos
    const token = data.token || data?.data?.token || null;
    const rolRaw = data.rol || data.usuario?.rol || null;
    const rol = rolRaw ? String(rolRaw).toLowerCase().trim() : null;
    const correoUsuario = data.usuario?.correo || data.correo || correo;
    const casilleroCodigo = data.usuario?.casilleroCodigo || data.casillero?.codigo || null;

    // Guardar en localStorage
    if (token) localStorage.setItem('token', token);
    if (rol) localStorage.setItem('rol', rol);
    if (correoUsuario) localStorage.setItem('correo', correoUsuario);
    if (casilleroCodigo) localStorage.setItem('casilleroCodigo', casilleroCodigo);

    return {
      success: !!data.success,
      mensaje: data.mensaje || (data.success ? 'Login exitoso' : 'Error en login'),
      token,
      usuario: data.usuario || null,
      rol,
      casillero: casilleroCodigo || null
    };
  } catch (err) {
    console.error('[AUTH] ❌ Error en login:', err.response?.data || err.message || err);
    return {
      success: false,
      mensaje: err?.response?.data?.mensaje || 'Error al iniciar sesión',
      token: null,
      usuario: null,
      rol: null,
      casillero: null
    };
  }
};

/**
 * 📝 Registrar nuevo usuario (cliente)
 */
export const register = async (payload) => {
  try {
    console.log('[AUTH] Payload enviado a /auth/register:', payload);

    const res = await api.post('/auth/register', payload);
    const data = unwrap(res);
    console.log('[AUTH] Respuesta recibida de /auth/register:', data);

    return {
      success: !!data.success,
      mensaje: data.mensaje || (data.success ? 'Registro exitoso' : 'Error en registro'),
      usuario: data.usuario || null,
      casillero: data.casillero || null
    };
  } catch (err) {
    console.error('[AUTH] ❌ Error en registro:', err.response?.data || err.message || err);
    return {
      success: false,
      mensaje: err?.response?.data?.mensaje || 'Error al registrar usuario',
      usuario: null,
      casillero: null
    };
  }
};

/**
 * ✅ Validar token actual
 */
export const validateToken = async () => {
  try {
    console.log('[AUTH] Validando token...');
    const res = await api.get('/auth/validate');
    const data = unwrap(res);
    console.log('[AUTH] Respuesta recibida de /auth/validate:', data);

    const casilleroCodigo = data.usuario?.casilleroCodigo || data.casillero?.codigo || null;

    return {
      success: !!data.success,
      mensaje: data.mensaje || (data.success ? 'Token válido' : 'Token inválido'),
      usuario: data.usuario || null,
      casillero: casilleroCodigo
    };
  } catch (err) {
    console.error('[AUTH] ❌ Error al validar token:', err.response?.data || err.message || err);
    return {
      success: false,
      mensaje: err?.response?.data?.mensaje || 'Error al validar token',
      usuario: null,
      casillero: null
    };
  }
};

/**
 * 🚪 Cerrar sesión
 */
export const logout = () => {
  console.log('[AUTH] Cerrando sesión y limpiando almacenamiento');
  ['token', 'rol', 'correo', 'casilleroCodigo'].forEach((key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (e) {
      console.warn('[AUTH] Error limpiando storage:', e);
    }
  });
  window.location.href = '/login';
};